import _overArg_default from "./_overArg.js";

//#region ../../node_modules/lodash-es/_nativeKeys.js
var nativeKeys = _overArg_default(Object.keys, Object);
var _nativeKeys_default = nativeKeys;

//#endregion
export { _nativeKeys_default as default };
//# sourceMappingURL=_nativeKeys.js.map